module.exports = __webpack_public_path__ + "img/logo3.39f5068b.png";